module.exports = __webpack_public_path__ + "assets/img/f6720380bd8d53d3b3fb85f251eae72e.png";